import { render, staticRenderFns } from "./Projectdetails.vue?vue&type=template&id=af4f485a&scoped=true&"
import script from "./Projectdetails.vue?vue&type=script&lang=js&"
export * from "./Projectdetails.vue?vue&type=script&lang=js&"
import style0 from "./Projectdetails.vue?vue&type=style&index=0&id=af4f485a&scoped=true&lang=css&"
import style1 from "./Projectdetails.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af4f485a",
  null
  
)

export default component.exports